import { BrowserRouter } from 'react-router-dom';
import AppRouter from './common/routes/router';
import "flatpickr/dist/flatpickr.min.css";
import "@/assets/scss/app.scss";
import { LayoutProvider } from './common/context/useLayoutContext';
import { ToastContainer, Zoom } from 'react-toastify';

function App() {
  return (
    <>
      <LayoutProvider>
        <BrowserRouter>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            transition={Zoom}
          />
          <AppRouter />
        </BrowserRouter>
      </LayoutProvider>
      {/* <DashboardPage /> */}
    </>
  );
}

export default App
